import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {EntitySureFlowUnit} from '../model/entity-sure-flow-unit';
import {WorkingSureFlowUnit} from '../model/working-sure-flow-unit';
import {SureFlowEntityRatingInput} from '../model/sure-flow-entity-rating-input';

@Service()
export class SureFlowUnitService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'sureFlow/unit/';

  getEntityLoopUnits(loopId: number): Observable<EntitySureFlowUnit[]> {
    const url = this.urlBase + 'entity/list/' + loopId;
    return this.http.get<EntitySureFlowUnit[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  getEntityLoopUnit(unitId: number): Observable<EntitySureFlowUnit> {
    const url = this.urlBase + 'entity/' + unitId;
    return this.http.get<EntitySureFlowUnit>(url, {headers: this.getRequestHeaders()});
  }

  saveEntityLoopUnits(unit: SureFlowEntityRatingInput): Observable<string> {
    const url = this.urlBase + 'entity';
    return this.http.post(url, JSON.stringify(unit), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(contentType: string = 'application/json'): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', contentType);
  }

  deleteEntityLoopUnits(ids: number[]): Observable<string> {
    const url = this.urlBase + 'entityUnits/delete';
    return this.http.post(url, JSON.stringify(ids), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  getWorkingLoopUnits(loopId: number): Observable<WorkingSureFlowUnit[]> {
    const url = this.urlBase + 'working/list/' + loopId;
    return this.http.get<WorkingSureFlowUnit[]>(url, {headers: this.getRequestHeaders()});
  }

  getWorkingLoopUnit(unitId: number): Observable<WorkingSureFlowUnit> {
    const url = this.urlBase + 'working/' + unitId;
    return this.http.get<WorkingSureFlowUnit>(url, {headers: this.getRequestHeaders()});
  }

  saveWorkingLoopUnit(unit: WorkingSureFlowUnit): Observable<WorkingSureFlowUnit> {
    const url = this.urlBase + 'working';
    return this.http.post<WorkingSureFlowUnit>(url, JSON.stringify(unit), {headers: this.getPostHeaders()});
  }

  deleteWorkingLoopUnit(unitId: number): Observable<string> {
    const url = this.urlBase + 'workingUnit/' + unitId;
    return this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  copyEntityUnits(input: SureFlowEntityRatingInput): Observable<string> {
    const url = this.urlBase + 'entity/copy';
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

  toggleSfrFlag(sfrNumber: string, input: SureFlowEntityRatingInput): Observable<string> {
    const url = this.urlBase + 'entity/toggleSfrFlag/' + encodeURIComponent(sfrNumber);
    return this.http.post(url, JSON.stringify(input), {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
